// ---- Persistence --------------------------------------------------------
// localStorage works in a normal browser. Every call is wrapped so that in a
// sandboxed context (where storage throws) we silently fall back to in-memory
// session state.

const STORAGE_KEY = "wc2026-bracket-v2";

export function loadSaved() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return {
      groupResults: parsed.groupResults ?? {},
      thirdsAdvancing: Array.isArray(parsed.thirdsAdvancing) ? parsed.thirdsAdvancing : [],
      winners: parsed.winners ?? {}
    };
  } catch {
    return null; // sandboxed or corrupt — ignore
  }
}

export function saveState(state) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // sandboxed / quota — no-op, session still works in memory
  }
}

export function clearSaved() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {}
}
